import React from 'react';
import './preview.scss';
import Messaging from '../../../context/Messaging';
/**
 * AOPS-59688/ AOPS-60315: PreviewModeBanner component.
 *
 * This component renders a banner with a help text for the preview mode.
 * It displays a message to inform users that they are in preview mode,
 * and some functionalities may be limited until full access is granted.
 * The banner is styled with specific classes to integrate seamlessly
 * with the local navigation header.
 *
 * The banner is sticky and will remain visible as part of the local navigation header
 * when the user scrolls.
 *
 * The original solution was to add a wrapper DIV around the local nav header and the app content container,
 * and use a border around the wrapper component to form the preview banner. This solution was very complex
 * given that we need a lot of modifications and checks around many levels of the containers to see if the user is active
 * to display the banner. So that's the reason we have this solution.
 */

// TODO: AOPS-59694 :- add a provision to get the preview banner text from the CMS. This will allow for dynamic content.

const PreviewModeBanner: React.FC = () => {
  return (
    <div role='region' aria-label='proctor preview message' className='preview-mode-local-nav-banner'>
      <div id='previewBannerText' className='container preview-mode-banner-text'>
        <Messaging dynamic preview section='navBanner' />
      </div>
    </div>
  );
};

export default PreviewModeBanner;
